import {
	ReactElement,
	useCallback,
	useEffect,
	useState
} from "react";
import { navigateTo } from "client_legacy/ndaw/navigator";
import {
	createNavigationUrl,
	hadErrors,
	crossStoreNotificationKindToOperationTypeMap,
	isCrossStoreFinishedNotificationDataViewModel
} from "../Content/CrossStoreActivity";
import { CrossStoreNotificationDataViewModel } from "client/Api/Notifications/notifications";
import {
	CrossStoreOperationErrorsDialog
} from "../../../Documents/Dialogs/CrossStoreOperationErrorsDialog";

export type CrossStoreActivityInvocationProps = {
	data: CrossStoreNotificationDataViewModel;
	onDismiss: () => void;
};

export const CrossStoreActivityInvocation = (props: CrossStoreActivityInvocationProps): ReactElement | null => {
	const {
		data,
		onDismiss
	} = props;

	const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);

	const onDismissHandler = useCallback(
		(): void => {
			setIsDialogOpen(false);
			onDismiss();
		},
		[onDismiss]
	);

	useEffect(
		() => {
			if (
				isCrossStoreFinishedNotificationDataViewModel(data)
				&& hadErrors(data)
			) {
				setIsDialogOpen(true);
			} else {
				const navigationUrl: string = createNavigationUrl(data.destination);
				navigateTo(navigationUrl);
				onDismiss();
			}
		},
		[data, onDismiss]
	);

	return isDialogOpen && isCrossStoreFinishedNotificationDataViewModel(data)
	? (
		<CrossStoreOperationErrorsDialog
			masterJobId={data.masterJobId}
			operationType={crossStoreNotificationKindToOperationTypeMap[data.kind]}
			onClose={onDismissHandler}
		/>
	)
	: null;
};

CrossStoreActivityInvocation.displayName = "CrossStoreActivityInvocation";